import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

export class RequestEmailVerificationAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(login, data, next, complete, error) {
    const httpConfig = {
      url: login
        ? '/request-email-verification'
        : '/d/request-email-verification',
      method: 'post',
      data: data,
      headers: {
        accept: 'application/json',
        'Content-Type': `application/json`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      login: login,
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
